import React from "react";
import ViewOrder from "./ViewOrder";
import ViewOrderV2 from "./ViewOrderV2";

const ViewOrderContainer = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const manageSecondaryOrderV2 = ConfigDictionary?.manageSecondaryOrderV2 ?? false;

  return manageSecondaryOrderV2 ? (
    <ViewOrderV2 />
  ) : (
    <ViewOrder />
  );
};

export default ViewOrderContainer;
